import abcjs from "abcjs";
import { jsPDF } from "jspdf";
import { svg2pdf } from "svg2pdf.js";
import "./DejaVuSerif-normal.js";
//import "./EBGaramond-Regular-normal.js";

$(function() {

    let abc = undefined;
    let title = undefined;
    let pieceKey = undefined;
    let transposition = {};

    let renderScale = undefined;
    let responsive = true;

    let noletra = false;

    let playGame = false;

    function getClef() {
        return $("select[name='clef']").val();
    }

    fetch("abc/index.json?" + Date.now())
        .then(response => {
            return response.json();
        }).then(setIndex);

    function setIndex(titles) {

        const html = [];
        const r = s => html.push(s);

        for (const title of titles) {
            const url = title + ".abc";
            r(`
<li>
  <a class="piece" data-url="abc/${encodeURIComponent(url)}">${title}</a>
</li>

      `);
        }
        $(".index").html(html.join(""));

        if (window.location.hash) {
            const url =  "abc/" + window.location.hash.replace(/^#/, "") + ".abc";
            setPiece(url);
        } else {
            $(".sidepanel").removeClass("closed");
        }

    }

    navigator.wakeLock && navigator.wakeLock.request("screen");

    $(document).on("click", ".piece", event => {
        const url = $(event.target).data("url");
        setPiece(url);
    });

    $(document).on("click", ".transpose", event => {
        transposition[abc] = transposition[abc] || 0;
        const inc = +($(event.target).data("inc"));
        if (inc) {
            transposition[abc] += inc;
        } else {
            transposition[abc] = 0;
        }
        renderABC();
    });
    $(document).on("change", "select[name='clef']", event => {
        renderABC();
    });

    $(document).on("click", ".download", event => {
        download();
    });

    $(document).on("click", ".game", event => {
        game();
    });

    $(document).on("click", ".fullscreen", event => {
        $("#transposed")[0].requestFullscreen();
    });

    $(document).on("fullscreenchange", event => {
        renderABC();
    });

    async function download() {

        const restore = responsive;
        responsive = false;

        scaleForOnePage();

        await renderPDF();

        responsive = restore;
        updateModel();
        renderABC();
    }

    async function renderPDF() {

        const pdf = new jsPDF("p", "mm", "a4");
        pdf.setFont("DejaVuSans", "normal");
//        pdf.setFont("EBGaramond-Regular", "normal");

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const svgElement = $("#transposed svg")[0];

        const width = svgElement.width.baseVal.value
        const height = svgElement.height.baseVal.value

        const a = pageWidth / width;
        const d = pageHeight / height;
        const z = Math.min(a, d);

        $("#transposed svg").attr("transform", `matrix(${z}, 0, 0, ${z}, 0, 0)`);

        const opts = {
            width: pdf.internal.pageSize.getWidth() * 10,
            height: pdf.internal.pageSize.getHeight() * 10
        };

        await svg2pdf(svgElement, pdf, opts);

        const filename = title + (pieceKey !== undefined ? ` (${pieceKey})` : "") + ".pdf";
        await pdf.save(filename);

        return pdf;
    }

    function updateModel() {
        renderScale = $("#scale").val();
    }
    updateModel();

    $(document).on("click", ".toc", event => {
        $(".sidepanel").removeClass("closed");
    });
    $(document).on("click", ".sidepanel .close", event => {
        $(".sidepanel").addClass("closed");
    });
    $(document).on("change", "#scale", event => {
        updateModel();
        renderABC();
    });
    $(document).on("change", "input[name='noletra']", event => {
        noletra = $(event.target).is(":checked");
        renderABC();
    });
    $(window).on("resize", () => {
        renderABC();
    });

    async function setPiece(url) {
        const response = await fetch(url + "?" + Date.now());
        abc = await response.text();
        $(".sidepanel").addClass("closed");
        renderABC();
        title = decodeURIComponent(url.replace(/\.abc$/, "").replace(/^abc\//, ""));
        $("title").text(title);
        window.location.hash = "#" + title;
        $("a.edit").attr("href", `e.html#${title}`);
    }

    async function game() {
        playGame = true;
        await renderABC();
        playGame = false;
    }

    async function renderABC(data) {
        abc = data || abc;
        if (abc) {

            const titleMatch = abc.match(/^T:(.*)/m);
            if (titleMatch) {
                title = titleMatch[1];
            }

            let abc2 = abc;

            const hasLetra = abc2.match(/^W:/m);

            if (hasLetra && noletra) {
                abc2 = abc2.replaceAll(/^W:.*/mg, "");
            }

            $(".letra").toggle(hasLetra);
            $("input[name='noletra']").prop("checked", noletra);

            const clef = getClef();
            if (clef) {
                abc2 = abc2.replace(/(X:.*)/, "$1\nK:clef=" + clef);
            }

            $(".score").show();

            const original = abcjs.renderAbc("original", abc2);

            const steps = transposition[abc] || 0;

            const abcTransposed0 = abcjs.strTranspose(abc2, original, steps);

            let abcTransposed;
            if (! playGame) {
                abcTransposed = abcTransposed0;
            } else {
                const original1 = abcjs.renderAbc("original", abcTransposed0);
                abcTransposed = addArticulations(abcTransposed0, original1);
            }

            const match = abcTransposed.match(/^K:([A-G][#b]?m?)/m);
            if (match) {
                pieceKey = match[1];

                pieceKey = pieceKey.replaceAll(/b/g, "♭");

                abcTransposed = abcTransposed.replace(/^T:(.*)/m, "T:$1 (" + pieceKey + ")");
            } else {
                pieceKey = undefined;
            }

            const scale = renderScale;

            const font = window.renderABCFont || "DejaVuSerif";

            const opts = {
                oneSvgPerLine: false,
                add_classes: true,
                scale: scale,
                format: {
                    gchordfont: font,
                    composerfont: font,
                    textfont: font,
                    gchordfont: font,
                    wordsfont: font,
                    headerfont: font,
                    footerfont: font,
                    partsbox: true,
                }
            };

            if (! responsive) {
                opts.print = true;
                opts.staffwidth = 740;
                opts.wrap = {
                    minSpacing: 1.8,
                    maxSpacing: 2.7,
                    preferredMeasuresPerLine: 6
                };
            } else {
                opts.staffwidth = $("body").width() - 30;
                opts.wrap = {
                    minSpacing: 1.8,
                    maxSpacing: 2.7,
                    preferredMeasuresPerLine: 8
                };
            }

            if (opts.wrap) {

                // Work around wrapping bug
                const lines = abcTransposed.split(/\n/);

                const lines2 = [];

                const isDirective = (i) => {
                    return i >= 0 && i < lines.length && lines[i].length > 1 && lines[i][1] == ":";
                }

                for (let i = 0; i < lines.length; i++) {
                    if (i == 0 || isDirective(i) || isDirective(i-1) || lines2.length == 0) {
                        lines2.push(lines[i]);
                    } else {
                        const last = lines2.length - 1;
                        lines2[last] = lines2[last] + " " + lines[i];
                    }
                }

                abcTransposed = lines2.join("\n");
            }

            const transposed = abcjs.renderAbc("transposed", abcTransposed, opts);

            $("#transposed").css("height", "auto");

            const height_px = $("#transposed").height();
            const height_mm = Math.floor(height_px / 3.78);

            const width_px = $("#transposed").width();
            const width_mm = Math.floor(width_px / 3.78);

            if (steps) {
                const s = Math.abs(steps);
                const dir = steps > 0 ? "up" : "down";
                const semitones = s == 1 ? "semitone" : "semitones";
                $(".transposition").text(`Transposed ${dir} ${s} ${semitones}`);
                $(".transposition").show();

            } else {
                $(".transposition").hide();
            }

        } else {
            $(".score").hide();
        }
    }

    function scaleForOnePage() {
        let scale = 1;

        const calc = () => {
            renderScale = scale;
            renderABC();
            const pixels = $("#transposed svg").height();

            const mm = pixels / 3.78;
            const max_mm = 270;
            const s =  max_mm / mm;

            console.log(`s=${s} from rendered pixels=${pixels} mm=${mm} (cf ${max_mm})`);

            return s;
        };

        const s0 = calc();
        if (s0 >= 1) {
            return;
        }

        let iters = 0;
        let maxIters = 20;
        let inc = 0.05;
        while (iters < maxIters) {

            iters ++;

            const s = calc();

            if (s > 0.9) {
                break;
            }

            if (s < 1) {
                scale -= inc;
            } else {
                scale += inc;
            }
            console.log(`iters=${iters} scale=${scale} s=${s}`);
        }

    }

    window.renderABC = renderABC;

    function addArticulations(abcString, tuneArray) {

        const regNote = /([_^=]*[A-Ga-g][,']*)(\d*\/*\d*)([\>\<\-\)\.\s\\]*)/;
        const regOptionalNote = /([_^=]*[A-Ga-g][,']*)?(\d*\/*\d*)?([\>\<\-\)]*)?/;
        const regSpace = /(\s*)$/;

        const articulations = [
            "staccato",
            "short accent",
            "long accent",
            "legato"
        ];

        const rules = {
            "long accent": {
                "staccato": true,
                "open_paren": true,
                "close_paren": true,
                "decoration": "!>!",
            },
            "short accent": {
                "staccato": true,
                "legato": true,
                "close_paren": true,
                "decoration": "!>!",
            },
            "legato": {
                "legato": true,
                "staccato": true,
                "open_paren": true,
            },
            "staccato": {
                "legato": true,
                "long accent": true,
                "short accent": true,
                "decoration": ".",
                "close_paren": true,
                "before_rest_ok": true,
            }
        };

        var paren = false;

        var lastArticulation = false;

        const abcTune = tuneArray[0];

        let changes = [];

        for (let i = 0; i < abcTune.lines.length; i++) {
            const staves = abcTune.lines[i].staff;
            if (staves) {
                for (var j = 0; j < staves.length; j++) {
                    var staff = staves[j]
                    changes = changes.concat(doVoices(abcString, staff.voices))
                }
            }
        }

        // Reverse sort so that we are replacing strings from the end to the beginning so that the indexes aren't invalidated as we go.
        // (Because voices can be written in different ways we can't count on the notes being encountered in the order they appear in the string.)
        changes = changes.sort(function (a, b) {
            return b.start - a.start
        })
        var output = abcString.split('')
        for (var i = 0; i < changes.length; i++) {
            var ch = changes[i]
            output.splice(ch.start, ch.end - ch.start, ch.note)
        }
        const out = output.join('')

        return out;

        function doVoices(abcString, voices) {
            var changes = [];
            for (var i = 0; i < voices.length; i++) {
                changes = changes.concat(doVoice(abcString, voices[i]));
            }
            return changes
        }

        function doVoice(abcString, voice) {

            let changes = []

            const notes = voice.filter((el) => {
                if (el.el_type !== "note") {
                    return false;
                }
                if (el.pitches && el.pitches[0].endTie) {
                    return false;
                }
                return true;
            });

            for (var i = 0; i < notes.length; i++) {
                var el = notes[i];
                if (el.pitches) {

                    const restFollows = i == notes.length - 1 || notes[i+1].rest;

                    const articulation = nextArticulation(restFollows);

                    changes.push(doNote(abcString, el.startChar, el.endChar, articulation));

                    lastArticulation = articulation;
                }
            }
            return changes;
        }

        function nextArticulation(restFollows) {
            if (restFollows) {
                return "staccato";
            }
            while (true) {
                const i = Math.floor(Math.random() * articulations.length);
                const articulation = articulations[i];
                const ok = (! lastArticulation || rules[lastArticulation][articulation]);
                console.log(`restFollows=${restFollows} last=${lastArticulation} art=${articulation} ok=${ok}`);
                if (ok) {
                    return articulation;
                }
            }
        }

        function doNote(abcString, start, end, articulation) {
            // There may be more than just the note between the start and end - there could be spaces, there could be a chord symbol, there could be a decoration.
            // This could also be a part of a chord. If so, then the particular note needs to be teased out.
            var note = abcString.substring(start, end);

            var match = note.match(new RegExp(regNote.source + regSpace.source), '');
            if (match) {
                // This will match a single note
                var noteLen = match[1].length;
                var trailingLen = match[2].length + match[3].length + match[4].length;
                var leadingLen = end - start - noteLen - trailingLen;
                start += leadingLen;
                end -= trailingLen;
            } else {
                // I don't know how to capture more than one note, so I'm separating them. There is a limit of the number of notes in a chord depending on the repeats I have here, but it is unlikely to happen in real music.
                var regPreBracket = /([^\[]*)/
                var regOpenBracket = /\[/
                var regCloseBracket = /\-?](\d*\/*\d*)?([\>\<\-\)]*)/
                match = note.match(new RegExp(regPreBracket.source + regOpenBracket.source + regOptionalNote.source +
                    regOptionalNote.source + regOptionalNote.source + regOptionalNote.source +
                    regOptionalNote.source + regOptionalNote.source + regOptionalNote.source +
                    regOptionalNote.source + regCloseBracket.source + regSpace.source))

                if (match) {
                    // This will match a chord
                    // Get the number of chars used by the previous notes in this chord
                    var count = 1 + match[1].length // one character for the open bracket
                    for (var i = 0; i < index; i++) { // index is the iteration through the chord. This function gets called for each one.
                        if (match[i * 3 + 2])
                            count += match[i * 3 + 2].length
                        if (match[i * 3 + 3])
                            count += match[i * 3 + 3].length
                        if (match[i * 3 + 4])
                            count += match[i * 3 + 4].length
                    }
                    start += count
                    var endLen = match[index * 3 + 2] ? match[index * 3 + 2].length : 0
                    // endLen += match[index * 3 + 3] ? match[index * 3 + 3].length : 0
                    // endLen += match[index * 3 + 4] ? match[index * 3 + 4].length : 0

                    end = start + endLen;
                }
            }

            const n = abcString.substring(start, end);

            const rule = rules[articulation];

            const decoration = rule.decoration || "";
            let open = "";
            let close = "";
            if (! paren) {
                if (rule.open_paren) {
                    paren = true;
                    open = "(";
                }
            } else if (paren) {
                if (rule.close_paren) {
                    paren = false;
                    close = ")";
                }
            }

            // console.log(`note=${n} lastArticulation=${lastArticulation} articulation=${articulation} open=${open} close=${close}`);

            return { start: start, end: end, note: open + decoration + n + close};
        }

    }

});
